(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesCustomerFormController', InvoicesCustomerFormController);

    InvoicesCustomerFormController.$inject = ['$state', 'InvoicesService', 'CountriesNewService'];

    function InvoicesCustomerFormController($state, InvoicesService, CountriesNewService) {
        var vm = this;        

        vm.loadCountries    = loadCountries;     
        vm.countries        = [];
        vm.loadRegions      = loadRegions;     
        vm.regions          = [];
        vm.loadCities       = loadCities;     
        vm.cities           = [];
        vm.selectedCountry;
        vm.selectedRegion;
        vm.selectedCity;

        vm.name;
        vm.contact_name;
        vm.email;
        vm.address;
        vm.telephone;

        vm.submit           = submit;

        vm.formErrors;

        vm.validateForm     = validateForm;

        activate();

        function activate() {
            loadCountries();
        }

        function loadCountries() {
            CountriesNewService.getCountries().then(function(response){
                vm.countries = response.data;                
            }); 
        }

        function loadRegions() {
            CountriesNewService.getRegions(vm.countrySelected.id).then(function(response){
                vm.regionSelected   = [];
                vm.citySelected     = [];
                vm.cities           = [];
                vm.regions          = response.data;

            }).catch(function(err) {

            });
        }

        function loadCities() {
            CountriesNewService.getCities(vm.countrySelected.id, vm.regionSelected.id).then(function(response){
                vm.citySelected = [];
                vm.cities       = response.data;

            }).catch(function(err) {

            });
        }

        function selectedCountry() {
            vm.selectRegion(vm.countrySelected.id);
        }

        function selectedRegion() {
            vm.selectCity(vm.countrySelected.id, vm.regionSelected.id);
        }

        function submit() {
            var country_selected_id = null;
            if (vm.countrySelected) {
                country_selected_id = vm.countrySelected.id;
            }

            var region_selected_id = null;
            if (vm.regionSelected) {
                region_selected_id = vm.regionSelected.id;
            }

            var city_selected_id = null;
            if (vm.citySelected) {
                city_selected_id = vm.citySelected.id;
            }

            vm.fields = {
                name                : vm.name,
                contact_name        : vm.contact_name,
                email               : vm.email,
                countries_id        : country_selected_id,
                region_id           : region_selected_id,
                city                : city_selected_id,
                address             : vm.address,
                telephone           : vm.telephone
            };

            InvoicesService.storeClient(vm.fields)
                    .then(function(response) {
                        if (response.errors) {
                            vm.formErrors = response.errors;
                        } else {
                            var params = { customer_created : 1 };
                            $state.go('root.invoices.general', params);
                        }
                    })
                    .catch(function(err) {
                        console.error(err);
                    });
        }

        function validateForm() {

            var fields = {                
                email: vm.email
            };

            InvoicesService.validateCustomer(fields)
                .then(function(response) {

                    vm.formErrors = [];

                    if (response.errors) {
                        vm.formErrors = response.errors;   

                        var focusKey = Object.keys(vm.formErrors)[0];
                        vm.focusMe = { [focusKey]: true };                        

                    }                    
                })
                .catch(function(err) {
                    console.error(err);
                });         
        }
        
    }

})();